import React, { useEffect, useContext } from "react";
import "../css/SplashScreen.css";
import { useNavigate } from "react-router-dom";
// import logo from "../assets/icons/logo.png";
import logo from "../assets/icons/dpboss.png";
import "../css/mainhome.css";
import { AppContext } from "../context/AppContext";
import apiClient from "../api/apiClient";

const clearBrokenAuth = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("registerId");
  localStorage.removeItem("userProfile");
};

const getStoredMobileNo = () =>
  localStorage.getItem("mobileNo") ||
  localStorage.getItem("lastLoginMobileNo") ||
  "";

const SplashScreen = () => {
  const navigate = useNavigate();
  const { setUser } = useContext(AppContext);

  useEffect(() => {
    let cancelled = false;

    const timer = setTimeout(async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const registerId = localStorage.getItem("registerId");
        const userProfile = localStorage.getItem("userProfile");

        if (accessToken && registerId) {
          if (userProfile && setUser) {
            try {
              setUser(JSON.parse(userProfile));
            } catch {
              localStorage.removeItem("userProfile");
            }
          }

          if (cancelled) return;
          navigate("/home", { replace: true });
          return;
        }

        clearBrokenAuth();
        const savedMobileNo = getStoredMobileNo();

        if (/^\d{10}$/.test(savedMobileNo)) {
          try {
            const res = await apiClient.post("/check-mobile", {
              mobileNo: savedMobileNo,
            });

            if (cancelled) return;

            if (res?.data?.status === true) {
              navigate("/login-with-mpin", { replace: true });
              return;
            }
          } catch (error) {
            console.error("Stored mobile check failed:", error?.response || error);
          }

          localStorage.removeItem("mobileNo");
          localStorage.removeItem("lastLoginMobileNo");
        }

        if (cancelled) return;
        navigate("/enter-mobile", { replace: true });
      } catch {
        clearBrokenAuth();
        if (!cancelled) navigate("/enter-mobile", { replace: true });
      }
    }, 2000);

    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [navigate, setUser]);

  return (
    <div className="splash-wrapper">
      <div className="splash-logo-box">
        <img src={logo} alt="Logo" className="splash-logo" />
      </div>

      <div className="splash-arc-back"></div>
      <div className="splash-arc-mid"></div>
      <div className="splash-arc-front"></div>
    </div>
  );
};

export default SplashScreen;
